// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OpeningHourExceptionResponse

import { OpeningHourEntityType } from './enums.gen';
import { DateTimefromYmd } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type OpeningHourExceptionApiResponse = {
	id: number;
	startDate: string;
	endDate: string;
	openingHourId: string;
	entityType: OpeningHourEntityType;
	entityId: string;
	weekName: string | null;
	entityName: string;
	color: string | null;
};

export type OpeningHourException = {
	id: number;
	startDate: DateTime;
	endDate: DateTime;
	openingHourId: string;
	entityType: OpeningHourEntityType;
	entityId: string;
	weekName: string | null;
	entityName: string;
	color: string | null;
};

export function hydrateOpeningHourException(data: OpeningHourExceptionApiResponse): OpeningHourException {
	return {
		...data,
		startDate: DateTimefromYmd(data.startDate)!,
		endDate: DateTimefromYmd(data.endDate)!,
	};
}